import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-medium tracking-widest uppercase text-primary-500 bg-primary-50 px-3 py-1 rounded-full">
            深度爆料
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
            深度爆料
          </h2>
          <p className="text-sm text-foreground-600 mt-2">编辑精选的深度扒料，信息量超乎想象</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardsData.map((item, i) => {
            const isLarge = i === 0;
            return (
              <div
                key={i}
                className={`bg-background-100 rounded-lg overflow-hidden border border-background-200/70 group cursor-pointer hover:border-primary-200 transition-colors duration-200 ${
                  isLarge ? 'lg:col-span-2' : ''
                }`}
              >
                <div
                  className={`overflow-hidden bg-background-200 ${
                    isLarge ? 'aspect-[16/7]' : 'aspect-[16/10]'
                  }`}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className={isLarge ? 'p-6 md:p-8' : 'p-5'}>
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs font-bold text-primary-500 bg-primary-50 px-2.5 py-1 rounded-full">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.date}</span>
                  </div>
                  <h3
                    className={`font-heading font-bold text-foreground-950 leading-snug mb-3 group-hover:text-primary-500 transition-colors duration-200 ${
                      isLarge ? 'text-xl md:text-2xl' : 'text-base'
                    }`}
                  >
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}